/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';

/* Style imports */
import './styles.css';

/*** End Imports ***/

const Section = (props) => {

    // helper function
    // event handlers for static component

    return (
        <div className="section-head">
            <p>{props.children}</p>
        </div>
    );
};

/**
 * all prop types which can be passed to this component
 */
Section.propTypes = {

};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
Section.defaultProps ={

};

export default Section;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/GetDataBaseView/Component/Section/Section.js